var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReportsActions = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 4,
  fill: "none",
  viewBox: "0 0 18 4",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#6C737F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2M16 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2M2 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
})));
export { SvgReportsActions as ReactComponent };
export default __webpack_public_path__ + "assets/images/reports_actions.svg";